export enum Feature {
  ActionableTaskView = 'Actionable Task View',
  BoardsPageTemplatePicker = 'Boards Page Template Picker',
  TeamlessCollaborationPrompt = 'Teamless Collaboration Prompt',
  TeamTemplatePicker = 'Team Template Picker',
  TeamProfile = 'Team Profile Header',
  TeamEditAvatar = 'Team Edit Avatar',
  Moonshot = 'moonshot',
  FreeTrialExistingTeam = 'Free Trial Existing Team',
  CardDetailDialog = 'Card Detail Dialog',
  CovidChurn = 'Covid Churn',
  UpgradePrompt = 'Upgrade Prompt',
  WorkspacesPreamble = 'Workspaces Preamble',
  TemplateTips = 'Template Tips',
  TeamOnboarding = 'Team Onboarding',
  TemplatesGallery = 'Templates Gallery',
  TemplatesInCreateFlow = 'Templates In Create Flow',
  CardFrontLinks = 'Card Front Links',
  UndoAction = 'Undo Action',
}
